(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot(){
    var l = document.getElementById('loader');
    if (!l) return;
    setTimeout(function(){
      l.classList.add('done');
      document.body.classList.add('loaded');
      setTimeout(function(){ l.style.display='none'; }, 1000);
    }, reduce ? 0 : 1150);
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, {threshold:.12, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  window.addEventListener('load', function(){
    setTimeout(function(){
      var hero = document.querySelector('.hero');
      if (hero) hero.classList.add('in');
    }, reduce?0:1150);
  });

  var cio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target, target = parseInt(el.dataset.count,10), pad = parseInt(el.dataset.pad||'0',10);
      cio.unobserve(el);
      if (reduce){ el.textContent = String(target).padStart(pad,'0'); return; }
      var start = performance.now(), dur = 1100;
      (function tick(now){
        var p = Math.min(1,(now-start)/dur), eased = 1-Math.pow(1-p,3);
        el.textContent = String(Math.round(eased*target)).padStart(pad,'0');
        if (p < 1) requestAnimationFrame(tick);
      })(start);
    });
  }, {threshold:.6});
  document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });

  var header = document.getElementById('header'), prog = document.getElementById('prog'), ticking = false;
  function onScroll(){
    var y = window.scrollY || 0;
    if (header) header.classList.toggle('stuck', y > 12);
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (prog) prog.style.width = (h > 0 ? (y/h)*100 : 0) + '%';
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if (!ticking){ ticking = true; requestAnimationFrame(onScroll); }
  }, {passive:true});
  onScroll();

  var art = document.getElementById('heroArt');
  var layers = art ? art.querySelectorAll('.layer') : [];
  var mx = 0, my = 0, cx = 0, cy = 0, sy = 0;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (!reduce && art && fine){
    art.addEventListener('mousemove', function(ev){
      var r = art.getBoundingClientRect();
      mx = (ev.clientX - r.left)/r.width - .5;
      my = (ev.clientY - r.top)/r.height - .5;
    });
    art.addEventListener('mouseleave', function(){ mx = 0; my = 0; });
    (function loop(){
      cx += (mx - cx)*.06; cy += (my - cy)*.06;
      var r = art.getBoundingClientRect();
      sy = Math.max(-1, Math.min(1, (window.innerHeight/2 - (r.top + r.height/2)) / window.innerHeight));
      layers.forEach(function(g){
        var d = parseFloat(g.dataset.depth||'10');
        g.setAttribute('transform','translate(' + (cx*d).toFixed(2) + ',' + (cy*d*.6 + sy*d*.9).toFixed(2) + ')');
      });
      requestAnimationFrame(loop);
    })();
  }

  if (!reduce && fine){
    document.querySelectorAll('.magnetic').forEach(function(el){
      el.addEventListener('mousemove', function(ev){
        var r = el.getBoundingClientRect();
        var x = ev.clientX - r.left - r.width/2, y = ev.clientY - r.top - r.height/2;
        el.style.transform = 'translate(' + x*.22 + 'px,' + y*.32 + 'px)';
      });
      el.addEventListener('mouseleave', function(){
        el.style.transition = 'transform .55s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
        setTimeout(function(){ el.style.transition = ''; }, 560);
      });
    });
  }

  if (!reduce && fine){
    document.querySelectorAll('.tilt').forEach(function(card){
      card.addEventListener('mousemove', function(ev){
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left)/r.width, py = (ev.clientY - r.top)/r.height;
        card.style.transform = 'perspective(1100px) rotateY(' + ((px-.5)*5).toFixed(2) + 'deg) rotateX(' + ((.5-py)*5).toFixed(2) + 'deg) translateY(-5px)';
        card.style.setProperty('--mx', (px*100) + '%');
        card.style.setProperty('--my', (py*100) + '%');
      });
      card.addEventListener('mouseleave', function(){ card.style.transform = ''; });
    });
  }

  var burger = document.getElementById('burger');
  if (burger){
    burger.addEventListener('click', function(){
      var open = document.body.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' && document.body.classList.contains('menu-open')){
        document.body.classList.remove('menu-open');
        document.body.style.overflow = '';
        burger.setAttribute('aria-expanded','false');
      }
    });
    document.querySelectorAll('#mobileNav a').forEach(function(a){
      a.addEventListener('click', function(){
        document.body.classList.remove('menu-open');
        document.body.style.overflow = '';
        burger.setAttribute('aria-expanded','false');
      });
    });
  }
})();
